<template>
  <section class="aidrama-box7">
    <!-- Pixso 65:4103 part7 — 393×518@1×；rem = @1× px × 2 -->
    <div class="aidrama-box7__inner">
      <header class="aidrama-box7__head">
        <h2 class="aidrama-box7__title">
          <span class="aidrama-box7__title-plain">以AI绘漫剧 </span>
          <span class="aidrama-box7__title-accent">凭作品见功底</span>
        </h2>
        <p class="aidrama-box7__sub">汇聚学员优质创作成果</p>
      </header>

      <div class="aidrama-box7__videos">
        <div
          v-for="(row, rowIndex) in videoRows"
          :key="rowIndex"
          class="aidrama-box7__row"
        >
          <button
            v-for="video in row"
            :key="video.id"
            type="button"
            class="aidrama-box7-video"
            :aria-label="video.label"
            @click="onVideoClick(video)"
          >
            <img
              class="aidrama-box7-video__img"
              :src="video.cover"
              alt=""
              loading="lazy"
              decoding="async"
            />
            <span class="aidrama-box7-video__play" aria-hidden="true">
              <span class="aidrama-box7-video__play-icon" />
            </span>
          </button>
        </div>
      </div>

      <ul class="aidrama-box7__shots">
        <li v-for="shot in shots" :key="shot.id" class="aidrama-box7__shot">
          <img
            class="aidrama-box7__shot-img"
            :src="shot.src"
            alt=""
            loading="lazy"
            decoding="async"
          />
        </li>
      </ul>

      <button type="button" class="aidrama-box7__cta" @click="handleCtaClick">
        <span class="aidrama-box7__cta-text">更多学员作品</span>
        <img class="aidrama-box7__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>

    <CourseVideo :src="videoSrc" :flag="videoFlag" @close="closeVideo" :specialStyle="2" :autoplay="true" />
  </section>
</template>

<script>
import CourseVideo from "../common/courseVideo.vue";

export default {
  name: "AidramaBox7",
  components: {
    CourseVideo,
  },
  data() {
    return {
      btnArrow: require("../../../assets/coursePage/aidrama/box8/btn_arrow.png"),
      videoFlag: false,
      videoSrc: "",
      videos: [
        {
          id: "v1",
          cover: require("../../../assets/coursePage/aidrama/box7/video_1.jpg"),
          label: "播放学员作品视频 1",
          link: "https://file.boxuegu.com/bxgyingxiao/vedio1.mp4",
        },
        {
          id: "v2",
          cover: require("../../../assets/coursePage/aidrama/box7/video_2.jpg"),
          label: "播放学员作品视频 2",
          link: "https://file.boxuegu.com/bxgyingxiao/vedio2.mp4",
        },
        {
          id: "v3",
          cover: require("../../../assets/coursePage/aidrama/box7/video_3.jpg"),
          label: "播放学员作品视频 3",
          link: "https://file.boxuegu.com/bxgyingxiao/video%286%29.mp4",
        },
        {
          id: "v4",
          cover: require("../../../assets/coursePage/aidrama/box7/video_4.jpg"),
          label: "播放学员作品视频 4",
          link: "https://file.boxuegu.com/bxgyingxiao/video%2815%29%281%29.mp4",
        },
      ],
      shots: [
        { id: "s1", src: require("../../../assets/coursePage/aidrama/box7/part7_x1.png") },
        { id: "s2", src: require("../../../assets/coursePage/aidrama/box7/part7_x2.png") },
        { id: "s3", src: require("../../../assets/coursePage/aidrama/box7/part7_x3.png") },
      ],
    };
  },
  computed: {
    videoRows() {
      return [this.videos.slice(0, 2), this.videos.slice(2, 4)];
    },
  },
  methods: {
    onVideoClick(video) {
      this.videoSrc = video.link;
      this.videoFlag = true;
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第7屏-学员作品视频", {
          终端: "H5",
          名称: "传智AI漫剧页-第7屏-" + video.label,
        });
      }
    },
    closeVideo() {
      this.videoFlag = false;
      this.videoSrc = "";
    },
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第7屏-更多学员作品", {
          终端: "H5",
          名称: "传智AI漫剧页-第7屏-更多学员作品",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box7 {
  width: 100%;
  box-sizing: border-box;
}

.aidrama-box7__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 80px 20px 104px;
  box-sizing: border-box;
}

/* 65:4104 gap 6px */
.aidrama-box7__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box7__title {
  margin: 0;
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  white-space: nowrap;
}

.aidrama-box7__title-plain {
  color: rgba(47, 52, 59, 1);
}

.aidrama-box7__title-accent {
  color: rgba(79, 86, 255, 1);
}

.aidrama-box7__sub {
  margin: 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(64, 69, 77, 1);
}

/* 65:4107 等 — 172×97；列 gap 9、行 gap 11 */
.aidrama-box7__videos {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  width: 100%;
  margin-top: 28px;
  padding: 0 4px;
  box-sizing: border-box;
}

.aidrama-box7__row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 18px;
  width: 100%;
}

.aidrama-box7-video {
  position: relative;
  flex: 0 0 344px;
  width: 344px;
  height: 194px;
  padding: 0;
  border: none;
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  background: #e8ecf0;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box7-video__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.aidrama-box7-video__play {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.aidrama-box7-video__play-icon {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 18px 0 18px 28px;
  border-color: transparent transparent transparent #fff;
  margin-left: 6px;
}

/* 65:4118 等 — 115/117×61；gap 3 */
.aidrama-box7__shots {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  margin: 18px 0 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
}

.aidrama-box7__shot {
  flex: 1 1 0;
  min-width: 0;
}

.aidrama-box7__shot-img {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 115 / 61;
  object-fit: cover;
  object-position: center;
}

.aidrama-box7__shot:nth-child(2) .aidrama-box7__shot-img,
.aidrama-box7__shot:nth-child(3) .aidrama-box7__shot-img {
  aspect-ratio: 117 / 61;
}

/* 65:4115 */
.aidrama-box7__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 40px;
  padding: 36px 60px 36px 72px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(
    270deg,
    rgba(188, 117, 255, 1) 0%,
    rgba(117, 104, 255, 1) 100%
  );
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box7__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box7__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
